import i18next from "i18next"
export const initI18n = (config?: any) => {
  i18next.init(config)
}
